import { createFileRoute } from '@tanstack/react-router';

import { VoiceLab } from '~/features/voice/dev/voice-lab';

/** Each voice hook against the real server, and every voice piece in its states. A developer page, open to anyone. */
export const Route = createFileRoute('/dev/voice')({ component: VoiceLab });
